import downloadFile from 'downloadjs';

import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';
import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { createReducer } from 'utils/redux';

import type { Action, ApiConfig, Deliverable, ThunkAction } from 'types';

const RECEIVE_DATA = 'campaignShippingAddresses/RECEIVE_DATA';
const RESET = 'campaignShippingAddresses/RESET';
const LOADING_STATE_CHANGED = 'campaignShippingAddresses/LOADING_STATE_CHANGED';

const initialState = {
  deliverableData: {},
  isLoading: false
};


export function loadingStateChanged(isLoading: boolean): Action {
  return {
    type: LOADING_STATE_CHANGED,
    payload: {
      isLoading
    }
  };
}

function receiveData(
  data: {
    [x: number]: Deliverable
  }
): Action {
  return {
    type: RECEIVE_DATA,
    payload: {
      data
    }
  };
}

export function resetCreatorsFirstTask() {
  return {
    type: RESET
  };
}

export function fetchCreatorsFirstTask(campaignId: number): ThunkAction {
  const url = API.END_POINTS.CAMPAIGNS.fetchCreatorsFirstTask(campaignId);
  return async (dispatch) => {
    dispatch(showLoading(url));
    dispatch(loadingStateChanged(true));

    try {
      const response = await get(url, {}, { suppressGlobalNotification: true });
      dispatch(receiveData(response.data));
      dispatch(hideLoading(url));
    } catch (err) {
      logError(err);
      dispatch(loadingStateChanged(false));
      dispatch(hideLoading(url));
    }
  };
}

export function downloadShippingAddresses(campaignId: number): ThunkAction {
  const url = API.END_POINTS.CAMPAIGNS.downloadShippingAddresses(campaignId);
  const requestConfig: Partial<ApiConfig> = {
    responseType: 'blob'
  };
  const fileName = 'Collabary Campaign Shipping Addresses.xlsx';

  return async (dispatch) => {
    dispatch(showLoading(url));

    try {
      const response = await get(url, requestConfig, { suppressGlobalNotification: true });
      downloadFile(response.data, fileName);
      dispatch(hideLoading(url));
    } catch (err) {
      logError(err);
      dispatch(hideLoading(url));
    }
  };
}

export default createReducer<any, any>('campaignShippingAddresses', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE_DATA]: (state, { data }) => ({
    ...state,
    deliverableData: data,
    isLoading: false
  }),
  [LOADING_STATE_CHANGED]: (state, { isLoading }) => ({
    ...state,
    isLoading
  })
});
